@import 'styles/variables';

.stepsContainer {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.step {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;

  &:not(:last-child) .stepIcon::after {
    content: '';
    position: absolute;
    left: 7px;
    top: 20px;
    bottom: -8px;
    border-left: 1.5px dashed var(--dark-15);
  }

  .collapsibleContainer &:not(:last-child) .stepIcon::after {
    display: none;
  }
}

.stepRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stepIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.completedIcon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--green);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pendingIcon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1.5px solid var(--dark-15);
}

.stepMeta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 24px;
  background: linear-gradient(
    92deg,
    rgba(0, 0, 0, 0.8) 4.97%,
    rgba(163, 163, 163, 0.8) 23.86%,
    rgba(0, 0, 0, 0.8) 42.76%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 500% auto;
  animation: textShine 2s ease-in-out infinite alternate;
}

@keyframes textShine {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}

.timer {
  font-variant-numeric: tabular-nums;
}

.collapsibleContainer {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
}

.headerRow {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
  color: inherit;
}

.timerRight {
  margin-left: auto;
  white-space: nowrap;
  flex-shrink: 0;
}

.chevron {
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinnerIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
